/**
 * Can be passed an array or individual arguments
 * getMax(1, 2, 3) or getMax([1, 2, 3])
 */
export default function getMax (...args) {
  let max = 'init'

  const processArr = arr => {
    arr.forEach(arg => {
      if (Array.isArray(arg)) {
        processArr(arg)
      } else if (typeof arg === 'number') {
        if (max === 'init') {
          max = arg
        } else {
          max = Math.max(max, arg)
        }
      }
    })
  }

  processArr(args)
  return max
}
